




























































import {Component, Prop, Watch} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "../../mixins/component-base.mixin";
import TableEditorsMixin from "../../mixins/table-editors.mixin";
import {PodsetnikOsobe, PrimaocPodsetnika} from "../../services/BackendProxies";
import dataProxy from "@/services/data-proxy.service"
import {validEmail} from "@/utils/validations";

@Component({})
export default class PodsetnikOsobeDialog extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop({default: false}) dialogVisible!: boolean;
    @Prop({default: undefined}) osobaId!: number;
    @Prop({default: undefined}) dateFromCalendar!: Date;
    @Prop() podsetnikOsobeRow!: PodsetnikOsobe;

    podsetnikOsobe = PodsetnikOsobe.fromJS({primaoci: [new PrimaocPodsetnika]});
    dialogOsobaData = false;
    columns = [];

    get invalidEmail() {
        const invalidEmails = this.podsetnikOsobe.primaoci.filter(x => !validEmail(x.email));
        return invalidEmails.length > 0;
    };

    get isInvalid() {
        return !this.podsetnikOsobe.osobaId || !this.podsetnikOsobe.upozoriPre
            || !this.podsetnikOsobe.datum || !this.podsetnikOsobe.opis || this.invalidEmail
    }

    async created() {
        if (this.osobaId) {
            this.podsetnikOsobe.osobaId = this.osobaId;
        }
        this.columns = [
            {field: 'osobaId', title: this.$i18n.t('osobe'), width: 300, formatter: this.osobeFormatter},
            {field: 'email', title: this.$i18n.t('email'), width: 260, formatter: this.emailFormatter},
            {
                field: 'ukljucen',
                width: 30,
                title: this.$i18n.t('ukljucen'),
                formatter: (value, row) => this.ukljucenFormatter(value, row)
            },
            {field: 'action', width: 10, align: 'right', formatter: `<i class="fa fa-trash text-danger"></i>`}
        ];
    }

    osobeFormatter(value, row) {
        return this.vueFormatter({
            template: `<mf-zaposleni-pripadnost :disabled="row.email !== undefined" parent="#dialogOsobe .modal-body" v-model="row.osobaId" @input="zaposleniChange(row)"></mf-zaposleni-pripadnost>`,
            data: { row },
            store: this.$store,
            methods: {zaposleniChange: this.zaposleniChange}
        })
    }

    zaposleniChange(row: PrimaocPodsetnika) {
        row.email = row.osobaId ? undefined : row.email;
        if (!row.osobaId) {
            row.osobaId = undefined;
        }
    }

    emailFormatter(value, row) {
        return this.vueFormatter({
            template: `
                <ValidationField v-slot="{classes}" rules="email" slim :immediate="true">
                    <input type="text" :disabled="row.osobaId" class="form-control grayInput" :class="classes"
                           @keypress.enter="dodajPrimaoca" v-model.lazy="row.email">
                </ValidationField>`,
            data: {row},
            methods: {dodajPrimaoca: this.dodajPrimaocaPodsetnikuOsobe}
        })
    }

    ukljucenFormatter(value, row) {
        return this.vueFormatter({
            template: `<b-form-checkbox v-model="row.ukljucen" switch></b-form-checkbox>`,
            data: { row }
        })
    }

    dodajPrimaocaPodsetnikuOsobe() {
        this.podsetnikOsobe.primaoci.push(PrimaocPodsetnika.fromJS({ukljucen: true}));
    }

    async onClickCell(field, value, row) {
        if (field === 'action') {
            this.podsetnikOsobe.primaoci = this.podsetnikOsobe.primaoci.filter(x => x != row);
        }
    }

    async sacuvajPodsetnikOsobe() {
        const valid = await (<any>this.$refs.observer).validate();
        if (!valid || this.isInvalid) {
            this.showError('podaci nisu validni');
            return;
        }
        this.podsetnikOsobe.primaoci = this.podsetnikOsobe.primaoci.filter(x => x.osobaId || x.email);
        this.podsetnikOsobe = await this.saveData(() => dataProxy.sacuvajPodsetnikOsobe(this.podsetnikOsobe))();
        this.podsetnikOsobe = PodsetnikOsobe.fromJS({primaoci: [new PrimaocPodsetnika]});
        if (this.osobaId) {
            this.podsetnikOsobe.osobaId = this.osobaId;
        }
        this.osveziTabelu();
    }

    osveziTabelu() {
        this.$emit('osveziTabelu')
    }

    @Watch('dialogVisible') onDialogVisibleChange(value) {
        this.dialogOsobaData = value;
        this.$nextTick(() => (<any>this.$refs.observer).validate());
        if (value) {
            this.podsetnikOsobe = PodsetnikOsobe.fromJS({primaoci: [new PrimaocPodsetnika]});
            if (this.osobaId) {
                this.podsetnikOsobe.osobaId = this.osobaId;
            }
            if (this.dateFromCalendar) {
                this.podsetnikOsobe.datum = this.dateFromCalendar;
            }
        }
    }

    @Watch('dialogOsobaData') onDialogOsobaDataChange(value) {
        this.$emit('input', value);
    }

    @Watch('podsetnikOsobeRow') onPodsetnikOsobeRowClicked(row) {
        if (row) {
            this.podsetnikOsobe = row;
        }
    }

    loader = async (params, success, failure) => {
        const opisiOsobe = await dataProxy.vratiOpisePodsetnikaOsoba(params.data.term);
        success(opisiOsobe);
    };

    processResults(data: any[]) {
        return {
            results: data.map((x) => ({id: x, text: x}))
        }
    }

    postBody() {
        this.vueFormatterPostBody();
        const input = $('input.invalid');
        if (input.length) {
            this.$nextTick(() => input[0].focus());
        }
    }

}
